import type { ChatRoom } from 'models';
import { Modal, Text } from 'ui';
import { ChatInfoModalContent } from '../../chat-info-modal-content';
import { ChatInfoProfile } from '../../chat-info-profile';
import { useChatUserInfo } from '../../hooks';
import { ChatUserInfoActions } from './chat-user-info-actions';

type P = {
  chatroom: ChatRoom;
  isOpened: boolean;
  onChatDeleted: () => Promise<void>;
  onClose: () => void;
};

const ChatUserInfoModal = ({ chatroom, isOpened, onChatDeleted, onClose }: P) => {
  const { email, name, photo, userId } = useChatUserInfo(chatroom);

  return (
    <Modal
      isOpened={isOpened}
      onCancel={onClose}
      title={
        <Text size="large" type="title" weight="medium">
          Chat info
        </Text>
      }
      width="medium"
    >
      <Modal.HugContent>
        <ChatInfoModalContent chatroom={chatroom} onChatDeleted={onChatDeleted} onClose={onClose}>
          <ChatInfoProfile
            actions={<ChatUserInfoActions userId={userId} />}
            description={email}
            name={name}
            photo={photo}
          />
        </ChatInfoModalContent>
      </Modal.HugContent>
    </Modal>
  );
};

export default ChatUserInfoModal;
